import mapValues from 'lodash/mapValues';
import { css } from 'styled-components';

import { breakpoints } from './breakpoints';

export const media = mapValues(
  // use any type here for now, typescript complains about strings vs TemplateStringsArray types
  (breakpoint: number) =>
    (...args: any) => css`
      @media (min-width: ${breakpoint / 16}em) {
        // Use css.call because Typescript doesn't recognize spread operators as an argument
        ${css.call(null, ...args)}
      }
    `,
  breakpoints,
);
